import { createContext, useContext, useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import { jwtDecode } from 'jwt-decode'

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

const login = (email, password) =>
    supabase.auth.signInWithPassword({ email, password });

const signOut = () => supabase.auth.signOut();

const signUp = (email, password, firstName, lastName) =>  
    supabase.auth.signUp({
          email: email,
          password: password,
          options: {
            data: {
              first_name: firstName,
              last_name: lastName,
              profile: "urgences"
            },
            //emailRedirectTo: "https://hopefoneadmin.sixnapsis.com/signin"
          }
        });

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [auth, setAuth] = useState(false);
    const [userRole, setUserRole] = useState(null);

    useEffect(() => {
        const { data } = supabase.auth.onAuthStateChange((event, session) => {

            if (["SIGNED_IN", "MFA_CHALLENGE_VERIFIED", "TOKEN_REFRESHED", "USER_UPDATED"].includes(event) && session) {
                const jwt = jwtDecode(session.access_token)
                // Si l'utilisateur a un facteur MFA vérifié, la session n'est valide qu'une fois le code saisi (aal2) :
                // après le seul mot de passe (aal1), l'utilisateur reste déconnecté côté app et les routes protégées
                // restent inaccessibles. Calcul local (pas d'appel Supabase dans ce callback, risque de blocage).
                const hasVerifiedFactor = (session.user?.factors ?? []).some((f) => f.status === "verified");
                if (hasVerifiedFactor && jwt.aal !== "aal2") {
                    console.log(event + " : MFA requis");
                    return;
                }
                setUser(session.user);
                setUserRole(jwt.user_role);
                setAuth(true);
                console.log(event);
            } else if (event === "SIGNED_OUT") {
                setUser(null);
                setAuth(false);
                setUserRole(null);
                console.log("SIGNED_OUT");
            }
        });
        return () => {
            data.subscription.unsubscribe();
        };
    }, []);

   

return (
    <AuthContext.Provider value={{ auth, user, login, signUp, signOut, userRole }}>
        {children}
    </AuthContext.Provider>
);
};

export default AuthProvider;